// extracted by mini-css-extract-plugin
export var wrapper = "homeCarouselBlockContent-module--wrapper--2yGQq";
export var button = "homeCarouselBlockContent-module--button--1p5gJ";
export var column = "homeCarouselBlockContent-module--column--3C5uj";